import { render, staticRenderFns } from "./MdmAppInstallPolicyModal.vue?vue&type=template&id=09006978&lang=pug&"
import script from "./MdmAppInstallPolicyModal.vue?vue&type=script&lang=js&"
export * from "./MdmAppInstallPolicyModal.vue?vue&type=script&lang=js&"
import style0 from "./MdmAppInstallPolicyModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports